export const STEP_FETCH_EVENT = 'STEP_FETCH_EVENT' as const;
export const STEP_PLATFORM_SELECTION = 'STEP_PLATFORM_SELECTION' as const;
export const STEP_LOGIN = 'STEP_LOGIN' as const;
export const STEP_ERROR = 'STEP_ERROR' as const;
export const STEP_SUCCESS = 'STEP_SUCCESS' as const;
export const STEP_END_OF_OPERATION = 'STEP_END_OF_OPERATION' as const;
export const STEP_GRANT_OWNERSHIP = 'STEP_GRANT_OWNERSHIP' as const;
